import AlertTable from "../../../Components/AlertTable.jsx";
import useAlertsList from "../../../Pages/AlertsList/useAlertsList.js";

export default function AdminAlerts() {
  const {
    alertsList,
    alertsLoading,
    currentPage,
    lastPage,
    totalAlertsCount,
    onToggleAlert,
    onPageChange,
  } = useAlertsList();

  return (
    <div className="min-h-screen p-4">
      <div className="mb-6 px-4">
        <div className="flex items-center justify-between mb-4">
          <h1 className="text-2xl font-bold text-white">Admin Alerts</h1>
        </div>
      </div>

      <AlertTable
        alertsData={alertsList}
        loading={alertsLoading}
        onToggle={onToggleAlert}
        currentPage={currentPage}
        lastPage={lastPage}
        totalCount={totalAlertsCount}
        onPageChange={onPageChange}
        showEdit={false}
        showDelete={false}
        showCreate={false}
      />
    </div>
  );
}


